import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Card, CardActionArea, CardContent, Grid, Typography } from '@mui/material';
import { MODULE_LIST } from '../theme/moduleColors';

const GlobalHome: React.FC = () => {
  const navigate = useNavigate();
  return (
    <Box sx={{ maxWidth: 1000, mx: 'auto', py: 4 }}>
      <Typography variant="h4" fontWeight={700} sx={{ mb: 1, color: '#e3e8ef' }}>LivestockFarmManager</Typography>
      <Typography variant="body1" sx={{ mb: 4, color: '#8899aa' }}>Select a module to get started</Typography>
      <Grid container spacing={2}>
        {MODULE_LIST.map((mod) => (
          <Grid item xs={12} sm={6} md={4} key={mod.id}>
            <Card sx={{ bgcolor: '#0d2137', border: '1px solid #1e3a5f', '&:hover': { borderColor: mod.accent } }}>
              <CardActionArea onClick={() => navigate(`/${mod.id}`)} sx={{ p: 2 }}>
                <CardContent>
                  <Typography variant="h6" fontWeight={600} sx={{ color: mod.accent, mb: 0.5 }}>{mod.label}</Typography>
                  <Typography variant="body2" sx={{ color: '#8899aa' }}>{mod.description}</Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default GlobalHome;
